const doc = [({"en":({"adminButtonHotelCalendar":({"deleteSpecifiedStaysOnlyPeriod":"Delete period"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;